export default () => ({
  requests: [],
  totalRequests: 0,
  searchTerm: '',
  pageSize: 10,
  sortDir: 'asc',
  orderBy: 'Id',
  status: '',
  filterBy: 0,
  schema: [],
  queryTemplates: [],
  logicChoices: [
    { name: '', value: 0 },
    { name: 'and', value: 1 },
    { name: 'or', value: 2 }
  ],
  categoryChoices: [
    { name: 'All', value: 0, checked: false },
    { name: 'Scan Type', value: 1, checked: false },
    { name: 'Status', value: 2, checked: false },
    { name: 'Tech', value: 3, checked: false },
    { name: 'Location', value: 4, checked: false },
    { name: 'Country', value: 5, checked: false },
    { name: 'Make', value: 6, checked: false },
    { name: 'Time Stats', value: 7, checked: false }
  ],
  currentTemplate: null
})



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/state.js